import { render, staticRenderFns } from "./EmployeesDataImport.vue?vue&type=template&id=567d324c"
import script from "./EmployeesDataImport.vue?vue&type=script&lang=js"
export * from "./EmployeesDataImport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports